import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// All API calls send cookies (admin session lives in an httpOnly cookie).
export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// -------- Public --------
export async function createLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function getLead(id) {
  const { data } = await api.get(`/leads/${id}`);
  return data;
}

export async function fetchEstimateConfig() {
  const { data } = await api.get("/public/estimate-config");
  return data;
}

export async function fetchBlockedDays(from, to) {
  const { data } = await api.get("/public/blocked-days", {
    params: { from, to },
  });
  return data;
}

// -------- Admin auth --------
export async function adminLogin(password) {
  const { data } = await api.post("/admin/login", { password });
  return data;
}

export async function adminLogout() {
  await api.post("/admin/logout");
}

export async function adminMe() {
  const { data } = await api.get("/admin/me");
  return data;
}

// -------- Admin data --------
export async function adminListLeads(statusFilter = "all") {
  const { data } = await api.get("/admin/leads", {
    params: { status: statusFilter },
  });
  return data;
}

export async function adminGetLead(id) {
  const { data } = await api.get(`/admin/leads/${id}`);
  return data;
}

export async function adminPatchLead(id, body) {
  const { data } = await api.patch(`/admin/leads/${id}`, body);
  return data;
}

export async function adminGetSettings() {
  const { data } = await api.get("/admin/settings");
  return data;
}

export async function adminPutSettings(body) {
  const { data } = await api.put("/admin/settings", body);
  return data;
}
